import script from "./CopyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=js"

import "./CopyButton.vue?vue&type=style&index=0&id=210f3a40&lang=scss"

const __exports__ = script;

export default __exports__